// extracted by mini-css-extract-plugin
module.exports = {"doughnut":"Doughnut_doughnut__g301h","graph":"Doughnut_graph__1RuE9","image":"Doughnut_image__4efQd"};